import { currencyDecimalPlaces, DEFAULT_CURRENCY } from './constants';

/**
 * Get the number of decimal places for a currency.
 * Falls back to 2 (most common) if currency is not found.
 */
export const getCurrencyDecimalPlaces = (currencyCode: string): number => {
  return currencyDecimalPlaces.get(currencyCode.toUpperCase()) ?? 2;
};

/**
 * Get the multiplier to convert major units to minor units for a currency.
 * E.g., USD (2 places) → 100, JPY (0 places) → 1, KWD (3 places) → 1000
 */
export const getMinorUnitMultiplier = (currencyCode: string): number => {
  const places = getCurrencyDecimalPlaces(currencyCode);
  return Math.pow(10, places);
};

/**
 * Convert a major unit amount to minor units for a given currency.
 * E.g., 10 USD → 1000 cents, 1000 JPY → 1000 (no conversion), 10 KWD → 10000 fils
 */
export const majorToMinorUnits = (amountInMajorUnits: number, currencyCode: string = DEFAULT_CURRENCY): number => {
  const multiplier = getMinorUnitMultiplier(currencyCode);
  return Math.round(amountInMajorUnits * multiplier);
};

/**
 * Convert a minor unit amount to major units for a given currency.
 * E.g., 1000 cents → 10 USD, 1000 JPY → 1000, 10000 fils → 10 KWD
 */
export const minorToMajorUnits = (amountInMinorUnits: number, currencyCode: string = DEFAULT_CURRENCY): number => {
  const multiplier = getMinorUnitMultiplier(currencyCode);
  return amountInMinorUnits / multiplier;
};
